module.exports = __webpack_public_path__ + "static/img/back.b23c0d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/funplus/imgs/back.png
// module id = 1903
// module chunks = 0